import { NgModule } from '@angular/core';

import { DeviceAuthenticationCoreApiService, DeviceAuthenticationStatusService } from '../api';

import { APOLLO_LINK_PROVIDERS } from './graphql/generated/schema.generated';
import { SysApiDeviceAuthenticationApiService } from './sys-api-device-authentication-api.service';
import { SysApiDeviceAuthenticationKeyringInjector } from './sys-api-device-authentication-keyring-injector.provider';
import { SysApiDeviceAuthenticationKeyringService } from './sys-api-device-authentication-keyring.service';

@NgModule({
	providers: [
		{
			provide: APOLLO_LINK_PROVIDERS,
			multi: true,
			useClass: SysApiDeviceAuthenticationKeyringInjector
		},
		{
			provide: DeviceAuthenticationCoreApiService,
			useExisting: SysApiDeviceAuthenticationApiService
		},
		SysApiDeviceAuthenticationKeyringService,
		DeviceAuthenticationStatusService
	]
})
export class SysApiDeviceAuthenticationDataAccessModule {}
